import { createWebHistory, createRouter } from "vue-router";

// Build up routes based on module architecture
import signupRoutes from '@/modules/signup/router';
import dashboardRoutes from '@/modules/dashboard/router';
import pagesRoutes from '@/modules/pages/router';

const defaultFallback = {
  path: '/',
  redirect: '/signup/language'
};

const baseRoutes = [defaultFallback];

const routes = baseRoutes.concat(signupRoutes, dashboardRoutes, pagesRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const loggedIn = !!window.localStorage.getItem("token");
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
//   if (requiresAuth && !loggedIn)
//     next({
//       name: "Language"
//     });
// });

export default router;